{
  "general": {
    "scroll_down": "Scroll naar beneden en ontdek meer"
  },
  "overview": {
    "start": {
      "title": "Maak jouw AI-toekomst mee",
      "description": "Hieronder zie je 7 AI-toepassingen waaraan vandaag in Vlaanderen wordt gewerkt. De makers willen graag weten hoe jij kijkt naar hun innovatie. Maak een keuze, lees meer en laat je mening achter!"
    },
    "return": {
      "title": "Bedankt voor jouw input!",
      "another_reaction": "Wil je nog een case bekijken?"
    }
  },
  "themes": {
    "nieuws": "Ga in gesprek met het nieuws",
    "sensor": "De intelligente geluidssensor voor thuis",
    "stress": "Steun bij stresspreventie en -herstel",
    "bubbel": "Deel je mening, doorbreek je bubbel",
    "ocmw": "Digitale steun bij OCMW-trajecten",
    "trainen": "Virtueel trainen voor moeilijke gesprekken",
    "elektro": "Automatisch elektro sorteren en hergebruiken"
  },
  "embed": {
    "closedQuestion": {
      "label": "Hoe sta je tegenover deze AI-toepassing?"
    },
    "openQuestion": {
      "label": {
        "1": "Waarom ben je kritisch?",
        "2": "Waarom ben je eerder kritisch?",
        "3": "Waarom twijfel je?",
        "4": "Waarom ben je eerder enthousiast?",
        "5": "Waarom ben je enthousiast?"
      }
    }
  }
}
